module.exports = __webpack_public_path__ + "images/oth-trigger-banner-mobile-bg.jpg";